import { toast } from "react-toastify";

export const validateLoginForm = ({ LoginId, Password }) => {
  // Check if email is empty or invalid
  if (!LoginId || LoginId.trim() === "") {
    toast.error("LoginId is required");
    return false;
  }
  // Check if password is empty or too short
  if (!Password || Password.trim() === "") {
    toast.error("Password is required");
    return false;
  }
  // If all validations pass
  return true;
};
